module.exports = __webpack_public_path__ + "static/img/bg_map@2x.bd59998.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/bg_map@2x.png
// module id = NlXF
// module chunks = 1